import { useEffect } from "react";

import {
  UnderwritingStatus,
  useFetchUwDecisionAndGeneratePaymentPlansQuery,
} from "@covertree/new-business-graphql";

export interface UsePaymentPlansProps {
  onError: (error?: Error) => void;
  onLoadingStart: () => void;
  onLoadingEnd: () => void;
  onUWDecision(decision: UnderwritingStatus): void;
  policyLocator: string;
}

export function usePaymentPlans({
  onError,
  onLoadingStart,
  onLoadingEnd,
  onUWDecision,
  policyLocator,
}: UsePaymentPlansProps) {
  const { data, loading, error } =
    useFetchUwDecisionAndGeneratePaymentPlansQuery({
      variables: {
        policyLocator,
      },
      fetchPolicy: "network-only",
    });

  useEffect(() => {
    if (loading) {
      onLoadingStart();
    }

    if (!loading && data) {
      onLoadingEnd();

      const { underwritingDecision } =
        data.fetchUWDecisionAndGeneratePaymentPlans;

      onUWDecision(underwritingDecision);
    }

    if (!loading && error) {
      onLoadingEnd();
      onError(error);
    }

    return () => {
      if (loading) {
        onLoadingEnd();
      }
    };
  }, [
    data,
    loading,
    error,
    onLoadingStart,
    onLoadingEnd,
    onError,
    onUWDecision,
  ]);

  return {
    forceAgentSignResponsibility:
      data?.fetchUWDecisionAndGeneratePaymentPlans
        ?.forceAgentSignResponsibility,
    paymentPlans: data?.fetchUWDecisionAndGeneratePaymentPlans?.paymentPlans,
    additionalInterests:
      data?.fetchUWDecisionAndGeneratePaymentPlans?.additionalInterests,
  };
}
